import { IGetAllProjetoListaUseCase } from "../../../presentation/useCases/read/get_all_projeto_lista_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { getProjetoListData } from "../../../data/daos/read/get_all_projetos_list";
import { ProjetoLista } from "../../models/projetos_Lista";
import { ProjetoFilter } from "../../models/projetos_filter";

/**
 * GetAllProjetoListaUseCase
 */

export class GetAllProjetoListaUseCase extends BasePaginatedUseCase<ProjetoLista> implements IGetAllProjetoListaUseCase {
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllProjetoLista(
    filter: ProjetoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getProjetoList(
      filter,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
